module.exports = __webpack_public_path__ + "static/premium-6-dollars-black-e8cdf183d68e974c6911606678ae7f2d.png";